import * as Yup from 'yup';
import { useSnackbar } from 'notistack';
// next
import { useRouter } from 'next/router';
// form
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
// routes
import { PATH_DASHBOARD } from '../../../routes/paths';
// campos do visual novo de autenticacao
import { BotaoAuth, CampoAuth, ENTRADA_AUTH } from '../CamposAuth';

/* ============================================================================
   Formulario de verificacao de codigo - visual novo.

   POR QUE VIROU UM CAMPO SO (nao seis campos de 1 digito como o template MUI):
   o componente original tinha 6 <OutlinedInput> com `id="field-code"` REPETIDO
   (id duplicado, invalido em HTML) e so tratava o foco AVANCANDO para o proximo
   campo ao digitar - nao havia nenhum handler de Backspace para voltar o foco ao
   campo anterior. Testando o comportamento: digitar avanca, mas apagar e tentar
   voltar deixa o cursor preso no campo atual, obrigando a clicar manualmente no
   campo anterior. Colar o codigo tambem dependia de `querySelectorAll('#field-code')`,
   que so funciona por acidente (varios elementos com o mesmo id) e quebra o
   contrato do HTML. Como o comportamento de ir-e-voltar nao funciona de verdade,
   a instrucao de migracao pede o campo unico - e um <input inputMode="numeric"
   autoComplete="one-time-code"> sozinho ja recebe o autofill de SMS/e-mail do
   proprio navegador em campo unico, o que os 6 campos separados impediam.

   Resto do comportamento mantido identico ao original: mesmo submit simulado
   (nao ha endpoint real de verificacao no projeto), mesmo redirecionamento para
   PATH_DASHBOARD.root e mesmo aviso de sucesso.
   ============================================================================ */

export default function VerifyCodeForm() {
  const { push } = useRouter();
  const { enqueueSnackbar } = useSnackbar();

  const VerifyCodeSchema = Yup.object().shape({
    codigo: Yup.string()
      .required('O código é obrigatório')
      .matches(/^\d{6}$/, 'Informe os 6 dígitos do código'),
  });

  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
  } = useForm({
    mode: 'onBlur',
    resolver: yupResolver(VerifyCodeSchema),
    defaultValues: { codigo: '' },
  });

  const onSubmit = async (data) => {
    try {
      // sem endpoint real de verificacao no backend deste projeto; mantido o
      // mesmo submit simulado que o formulario original ja fazia
      await new Promise((resolve) => setTimeout(resolve, 500));

      enqueueSnackbar('Código verificado com sucesso!');
      push(PATH_DASHBOARD.root);
    } catch (error) {
      // defeito corrigido: o original so tinha console.error e nunca avisava
      // o usuario quando o "envio" falhava
      console.error(error);
      enqueueSnackbar('Não foi possível verificar o código.', { variant: 'error' });
    }
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)} className="space-y-3.5" noValidate>
      <CampoAuth
        id="verify-codigo"
        rotulo="Código de verificação"
        erro={errors.codigo?.message}
        dica="Digite os 6 dígitos recebidos por e-mail."
      >
        <input
          id="verify-codigo"
          className={`${ENTRADA_AUTH} text-center text-[20px] font-semibold tracking-[6px]`}
          autoComplete="one-time-code"
          inputMode="numeric"
          maxLength={6}
          autoFocus
          placeholder="------"
          aria-invalid={Boolean(errors.codigo)}
          {...register('codigo')}
        />
      </CampoAuth>

      <BotaoAuth carregando={isSubmitting} rotuloCarregando="Verificando...">
        Verificar
      </BotaoAuth>
    </form>
  );
}
